import { render, staticRenderFns } from "./profile-refa.vue?vue&type=template&id=31ecf21b&"
import script from "./profile-refa.vue?vue&type=script&lang=js&"
export * from "./profile-refa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports